import React, { lazy, Suspense } from 'react'

import { JACKPOT_ENABLED } from '../App/constants'
import JackpotsWidgetLoader from '../Jackpots/List/styles/Loader'

const Component = lazy(() => import(/* webpackChunkName: "Jackpot" */ './index'))

export default function Loadable() {
  if (!JACKPOT_ENABLED) {
    return null
  }

  return (
    <Suspense fallback={<JackpotsWidgetLoader />}>
      <Component />
    </Suspense>
  )
}
